/// <reference path="../../../types/BuilderFactoryTypes.ts" />
/// <reference path="../../../gui/Builder.ts" />

namespace SPA
{
	export namespace Customer
	{
		export namespace gui
		{
			export class CustomerFactory
			{
				private constructor() {}

				public static createBuilder( object: Wollmilch.CustomerObject ) : SPA.gui.OrganizationBuilder<Wollmilch.ComponentObject>
				{
					if ( 'Surname' in object.Customer )
					{
						return new ClientCustomerBuilder( object.Customer as Wollmilch.ClientObject, object.CNO );
					}
					else
					{
						return new CompanyCustomerBuilder( object.Customer as Wollmilch.CompanyObject, object.CNO );
					}
				}
			}

			export class Factory
			{
				private constructor(){}

				public static createBuilder( type: SPA.types.BuilderFactoryType , object: Wollmilch.ComponentObject )
				{
					if ( type == SPA.types.BuilderFactoryType.customer )
					{
						// return CustomerFactory.createBuilder( object as W );
					}

					throw new Error( type + ' not implemented yet.' );
				}
			}
		}
	}
}
